<!--
 * @Description:
 * @Author: JiuYue
 * @Date: 2020-10-23 12:05:43
 * @Reference:
-->
<template>
  <a-modal
    :title="viewTitle"
    visible
    @cancel="cancel"
  >
    <ak-inputs :options="editFields" ref="inputs" v-model="record" />
    <template slot="footer">
      <a-button type="primary" @click="cancel">确定</a-button>
    </template>
  </a-modal>
</template>

<script>
export default {
  name: 'viewPage',
  data () {
    return {}
  },
  computed: {
    editFields () {
      let data = this.model.fields.filter(field => !field.hideOnEdit)
      let arr = []
      data.forEach((e) => {
        let obj = {}
        if (e.disabled) {
          obj = { ...e.schema, name: e.name, disabled: true }
        } else {
          obj = { ...e.schema, name: e.name, disabled: true }
        }
        if (obj.name === 'wechatName') { obj.note = '评论者' }
        arr.push(obj)
      })
      return arr
    }
  },
  methods: {
    cancel () {
      this.$emit('complete', 'cancel')
    }
  },
  props: {
    record: Object, // 当前行的数据
    model: Object, // 当前model对象
    field: Object, // 当前field对象
    viewTitle: {
      type: String,
      default: '查看综合执法'
    }
  }
}
</script>

<style scoped>

</style>
